// removed by extract-text-webpack-plugin
module.exports = {"event-level-dot":"_3oYTt6wkmZ-vCBQQnFV0zE_0","txt":"_1k9iBxTASJuiB51kycAtqS_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-66d44928","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/frame/components/popup/EventPopover.vue
// module id = Hyj5
// module chunks = 75